import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPreviousDevotionals } from "@/data/devotionals";
import { DevotionalVersionSelector } from "./devotional/DevotionalVersionSelector";
import { DevotionalMainContent } from "./devotional/DevotionalMainContent";
import { DevotionalShare } from "./devotional/DevotionalShare";
import { BackToTopButton } from "./BackToTopButton";

interface DevotionalContentProps {
  date: string;
  title: string;
  topic: string;
  memoryVerse: {
    reference: string;
    text: string;
  };
  text: {
    reference: string;
    content: string;
  };
  message: string;
  prayer: string;
  finalWord: {
    reference: string;
    text: string;
  };
  spouseToSpouse: {
    question: string;
    reconciliation: string;
    prayers: string[];
  };
  morningPrayers: {
    confessions: string[] | string;
    prayerPoints: string[] | string;
  };
  eveningPrayers: {
    confessions: string[] | string;
    prayerPoints: string[] | string;
  };
  authors: {
    names: string;
    image: string;
    bio: string;
  };
  userId?: string;
}

export const DevotionalContent = (props: DevotionalContentProps) => {
  const [version, setVersion] = useState<"classic" | "essential">("classic");
  
  const { data: previousDevotionals = [] } = useQuery({
    queryKey: ["previousDevotionals", props.date],
    queryFn: () => getPreviousDevotionals(new Date(props.date), 5),
  });

  return (
    <div className="max-w-2xl mx-auto space-y-8 p-4">
      <DevotionalVersionSelector
        date={props.date}
        topic={props.topic}
        version={version}
        onVersionChange={setVersion}
      />

      <DevotionalShare title={props.title} date={props.date} />

      <DevotionalMainContent
        version={version}
        text={props.text}
        memoryVerse={props.memoryVerse}
        message={props.message}
        finalWord={props.finalWord}
        spouseToSpouse={props.spouseToSpouse}
        morningPrayers={props.morningPrayers}
        eveningPrayers={props.eveningPrayers}
        userId={props.userId}
        devotionalId={props.date}
      />

      <BackToTopButton />
    </div>
  );
};